import { useContext } from 'react';
import { NotificationStatusReportJobContext } from './context';

export default function useNotificationStatusReportJobContext() {
  return useContext(NotificationStatusReportJobContext);
}
